import { render, staticRenderFns } from "./titelbild.vue?vue&type=template&id=0b823e9d&scoped=true"
import script from "./titelbild.vue?vue&type=script&lang=js"
export * from "./titelbild.vue?vue&type=script&lang=js"
import style0 from "./titelbild.vue?vue&type=style&index=0&id=0b823e9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b823e9d",
  null
  
)

export default component.exports